import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5e3f87b0&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5e3f87b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3f87b0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('D:/xtdt-qna-fe/components/Footer/Footer.vue').default})
